import React from 'react';
import "../styles/index.css"
import card_video from "../img/chai-background.mp4"
import wholesale from "../img/wholesale.jpg"


const Order = () => {

	return (

	<div >
		<video autoPlay loop muted playsInline className="card-video">
			<source src={card_video} type="video/mp4" />
		</video>

		<div className="outer-content">
    <div className="on-top">
      <div className="inside-div">
      <h2 className='topic-heading'>
                <b>Wholesale Chai Orders</b>
        </h2>
      <div className="main-content">

      

        <div className="card-left">
          <p className='upcoming-text medium-text'>
            In case you aren't able to visit us at our infamous cart, you can also order our chai for parties, gatherings, and whenever you and your friends feel like hanging out and sipping chai! <br></br>
			We offer wholesale chai orders in Illinois suburbs, and plan to grow soon! <br></br>
			<strong>Flavors:</strong><br></br>
			Masala Chai (hot) <br></br>
			Iced Chai (cold)<br></br>

			

          </p>	
		  
                <a href="https://forms.gle/2niDN5CAkR1ehpd9A" activeStyle className="hamburger-text">
                <button className="action-button">Click to Order Chai Now!</button>
                </a>
            
        </div>

        <div className="card-right">
          <img className="medium-image" alt="wholesale_image" src={wholesale}></img>
        </div>
        
      </div>


     
      </div>
    </div>
     

			
		</div>
	</div>
		
	);
};

export default Order;


